export const selectNewTradeType = (state) => state.appReducer.orders.openTradeSellBuy
export const selectStopLoss = (state) => state.appReducer.orders.stopLoss || ''
export const selectTakeProfit = (state) => state.appReducer.orders.takeProfit || ''
export const selectStopLossLine = (state) => state.appReducer.orders.stopLossLine || ''
export const selectTakeProfitLine = (state) => state.appReducer.orders.takeProfitLine || ''
export const selectIsSunday = (state) => state.appReducer.orders.isSunday || null
export const selectLotCountData = (state) => state.appReducer.orders.lotCountData || null
export const selectLeverage = (state) => state.appReducer.orders.leverage || 0
export const selectPipValue = (state) => state.appReducer.orders.pipValue
export const selectUsedMargin = (state) => state.appReducer.orders.usedMargin
export const selectSpread = (state) => state.appReducer.orders.spread
export const selectExecutionEntryRate = (state) => state.appReducer.orders.executionEntryRate
export const selectDelayPricer = (state) => state.appReducer.orders.delayPricer
export const selectLots = (state) => state.appReducer.orders.lots
